module.exports = __webpack_public_path__ + "img/xhtml.88ff9dbb.svg";